import { Component, DEFAULT_CURRENCY_CODE, inject, LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { SettingsService } from 'hakikat/services';
import { Currency, Locale } from 'hakikat/utils';

export type LocaleOption = { id: Locale, label: string };

@Component({
  selector: 'app-localize',
  imports: [FormsModule],
  templateUrl: './localize.component.html',
  styleUrl: './localize.component.scss'
})
export class LocalizeComponent {

  //#region Properties
  currencies: Currency[] = Object.values(Currency);

  locales: LocaleOption[] = [
    { id: Locale.de_DE, label: 'Deutsch' },
    { id: Locale.en_US, label: 'English' },
    { id: Locale.tr_TR, label: 'Türkçe' }
  ];
  //#endregion

  //#region Service Materials
  readonly #currency: string = inject(DEFAULT_CURRENCY_CODE);
  readonly #localeId: string = inject(LOCALE_ID);

  readonly #settingsService: SettingsService = inject(SettingsService);
  //#endregion

  //#region Getter & Setter
  public get currency(): string {
    return this.#currency;
  }

  public set currency(value: Currency) {
    this.#settingsService.localization.setCurrencyAndReload(value);
  }

  public get localeId(): string {
    return this.#localeId;
  };

  public set localeId(value: Locale) {
    this.#settingsService.localization.setLocaleAndRedirect(value);
  }
  //#endregion
}
